var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dashboard-root" },
    [
      _c(
        "div",
        {
          staticClass: "flex items-center gap-20px mobile-header-content",
          on: { click: _vm.toggleMobileMenu },
        },
        [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "title", staticStyle: { color: "#A40000" } },
            [_vm._v("云南省高校人才市场")]
          ),
        ]
      ),
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.mobileMenuVisible,
            expression: "mobileMenuVisible",
          },
        ],
        staticClass: "mobile-overlay",
        on: { click: _vm.closeMobileMenu },
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.mobileMenuVisible,
              expression: "mobileMenuVisible",
            },
          ],
          staticClass: "mobile-sidebar",
          class: { "mobile-open": _vm.mobileMenuVisible },
        },
        [
          _c("div", { staticClass: "title" }, [_vm._v("云南省高校人才市场")]),
          _vm.menuList.length && _vm.showMenu
            ? _c(
                "div",
                { staticClass: "menu" },
                [
                  _vm._l(_vm.menuList, function (item, index) {
                    return [
                      _c(
                        "div",
                        {
                          key: item.path,
                          staticClass: "menu-item",
                          on: {
                            click: function ($event) {
                              return _vm.meunItemClick({ item, index })
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "item-l",
                              class: {
                                "active-bg": index === _vm.currentRouteIndex,
                              },
                            },
                            [
                              _c("img", {
                                attrs: { src: _vm.getMenuIcon(index), alt: "" },
                              }),
                              _c("span", { staticClass: "title-text" }, [
                                _vm._v(" " + _vm._s(item.meta.title) + " "),
                              ]),
                            ]
                          ),
                          index === _vm.currentRouteIndex
                            ? _c("div", { staticClass: "icon-caret-left" })
                            : _vm._e(),
                        ]
                      ),
                    ]
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "menu-item",
                      on: {
                        click: function ($event) {
                          return _vm.$router.push({ name: "exam-examlist" })
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "item-l" }, [
                        _c("img", {
                          attrs: { src: _vm.getMenuIcon(3), alt: "" },
                        }),
                        _c("span", { staticClass: "title-text" }, [
                          _vm._v(" 返回首页 "),
                        ]),
                      ]),
                    ]
                  ),
                ],
                2
              )
            : _vm._e(),
        ]
      ),
      _c(
        "el-container",
        { staticClass: "dashboard-container" },
        [
          _c(
            "el-aside",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showMenu,
                  expression: "showMenu",
                },
              ],
              staticClass: "dashboard-aside",
            },
            [
              _c("div", { staticClass: "title" }, [
                _vm._v("云南省高校人才市场"),
              ]),
              _vm.menuList.length
                ? _c(
                    "div",
                    { staticClass: "menu" },
                    [
                      _vm._l(_vm.menuList, function (item, index) {
                        return [
                          _c(
                            "div",
                            {
                              key: item.path,
                              staticClass: "menu-item",
                              on: {
                                click: function ($event) {
                                  return _vm.meunItemClick({ item, index })
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item-l",
                                  class: {
                                    "active-bg":
                                      index === _vm.currentRouteIndex,
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.getMenuIcon(index),
                                      alt: "",
                                    },
                                  }),
                                  _c("span", { staticClass: "title-text" }, [
                                    _vm._v(" " + _vm._s(item.meta.title) + " "),
                                  ]),
                                ]
                              ),
                              index === _vm.currentRouteIndex
                                ? _c("div", { staticClass: "icon-caret-left" })
                                : _vm._e(),
                            ]
                          ),
                        ]
                      }),
                      _c(
                        "div",
                        {
                          staticClass: "menu-item",
                          on: {
                            click: function ($event) {
                              return _vm.$router.push({ name: "exam-examlist" })
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "item-l" }, [
                            _c("img", {
                              attrs: { src: _vm.getMenuIcon(3), alt: "" },
                            }),
                            _c("span", { staticClass: "title-text" }, [
                              _vm._v(" 返回首页 "),
                            ]),
                          ]),
                        ]
                      ),
                    ],
                    2
                  )
                : _vm._e(),
            ]
          ),
          _c("el-main", { staticClass: "dashboard-main" }, [
            _c("div", { staticClass: "dashboard-header" }, [
              _c("div", { staticClass: "flex items-center gap-20px" }, [
                _c("img", {
                  staticClass: "icon-user",
                  attrs: {
                    src: require("@/assets/images/login/avatar.png"),
                    alt: "",
                  },
                }),
                _c("span", [_vm._v("您好, " + _vm._s(_vm.userInfo?.mobile))]),
              ]),
              _c(
                "div",
                {
                  staticClass: "flex items-center header-actions",
                  staticStyle: { cursor: "pointer" },
                },
                [
                  _vm.showPostStat
                    ? _c(
                        "div",
                        {
                          staticClass: "flex items-center gap-10px",
                          on: { click: _vm.openPostStat },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-data-analysis action-icon",
                          }),
                          _c("span", { staticClass: "action-text" }, [
                            _vm._v("岗位报名情况"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm.showManual
                    ? _c(
                        "div",
                        {
                          staticClass: "flex items-center gap-10px",
                          on: {
                            click: function ($event) {
                              return _vm.openManual()
                            },
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "icon-logout",
                            attrs: {
                              src: require("@/assets/images/login/zhinan.png"),
                              alt: "",
                            },
                          }),
                          _c("span", { staticClass: "action-text" }, [
                            _vm._v("操作手册"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "el-popover",
                    {
                      ref: "messagePopover",
                      attrs: {
                        "popper-class": "message-popover",
                        placement: "bottom-end",
                        width: "340",
                        trigger: "click",
                      },
                      model: {
                        value: _vm.messagePopoverVisible,
                        callback: function ($$v) {
                          _vm.messagePopoverVisible = $$v
                        },
                        expression: "messagePopoverVisible",
                      },
                    },
                    [
                      _c("div", { staticClass: "message-popover" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex items-center justify-between popover-header",
                          },
                          [
                            _c("span", { staticClass: "popover-title" }, [
                              _vm._v("消息通知"),
                            ]),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "text",
                                  disabled: _vm.unreadNotifyCount === 0,
                                },
                                on: { click: _vm.handleReadAll },
                              },
                              [_vm._v("全部已读")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "message-popover-body" },
                          [
                            _vm.messageLoading
                              ? _c("div", { staticClass: "message-tip" }, [
                                  _vm._v("加载中…"),
                                ])
                              : _vm.messageList.length === 0
                              ? _c("div", { staticClass: "message-tip" }, [
                                  _vm._v("暂无消息"),
                                ])
                              : _vm._l(_vm.messageList, function (item) {
                                  return _c(
                                    "div",
                                    {
                                      key: item.id,
                                      staticClass: "message-item",
                                      class: { unread: !item.readStatus },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openDetail(item)
                                        },
                                      },
                                    },
                                    [
                                      !item.readStatus
                                        ? _c("span", {
                                            staticClass: "message-dot",
                                          })
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        { staticClass: "message-item-content" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "message-item-title",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(item.templateNickname)
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "message-item-text",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(item.templateContent)
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "message-item-time",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatTime(
                                                    item.createTime
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }),
                          ],
                          2
                        ),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center gap-10px message-bell",
                          attrs: { slot: "reference" },
                          slot: "reference",
                        },
                        [
                          _c(
                            "el-badge",
                            {
                              attrs: {
                                value: _vm.unreadNotifyCount,
                                hidden: _vm.unreadNotifyCount === 0,
                                max: 99,
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-message action-icon",
                              }),
                            ]
                          ),
                          _c("span", { staticClass: "action-text" }, [
                            _vm._v("消息"),
                          ]),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "flex items-center gap-10px",
                      on: { click: _vm.onLogout },
                    },
                    [
                      _c("img", {
                        staticClass: "icon-logout",
                        attrs: {
                          src: require("@/assets/images/login/logout.png"),
                          alt: "",
                        },
                      }),
                      _c("span", { staticClass: "action-text" }, [
                        _vm._v("退出"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "app-main" }, [_c("router-view")], 1),
          ]),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "岗位报名情况",
            visible: _vm.postStatVisible,
            width: "900px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.postStatVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "margin-bottom": "12px",
                color: "#909399",
                "font-size": "12px",
              },
            },
            [_vm._v("数据实时统计，仅供参考")]
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.postStatLoading,
                  expression: "postStatLoading",
                },
              ],
              staticClass: "post-stat-table",
              attrs: {
                data: _vm.postStatList,
                border: "",
                "max-height": "480",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "报考单位",
                  prop: "deptName",
                  "min-width": "180",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "报考岗位",
                  prop: "postName",
                  "min-width": "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "岗位代码",
                  prop: "postCode",
                  width: "110",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "录用人数",
                  prop: "headcount",
                  width: "90",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "报名人数",
                  prop: "signUpCount",
                  width: "90",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "审核通过人数",
                  prop: "auditPassCount",
                  width: "110",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "交费人数",
                  prop: "payCount",
                  width: "90",
                  align: "center",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "menu-toggle-btn" }, [
      _c("i", { staticClass: "el-icon-s-fold" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }